const $body = $('body');

$('[data-toggle="tooltip"]').each(function () {
    let $trigger = $(this),
        ttText = $(this).attr('title');

    if (typeof ttText !== 'undefined') {

        let ttClass = 'tooltip',
            ttPlacement = $(this).attr('data-placement');

        if (typeof ttPlacement !== 'undefined') {
            ttClass += ' tooltip--placement-' + ttPlacement;
        }

        let $tooltip = $('<div class="' + ttClass + '" role="tooltip"><div class="tooltip__arrow"></div><div class="tooltip__inner">' + ttText + '</div></div>');

        $(this).on('mouseover', function () {
            let ttID = 'tooltip-' + randomInteger(10000, 99999);

            $body.append($tooltip);

            $tooltip.attr('id', ttID);
            $tooltip.setTooltipPosition($trigger, ttPlacement);

            $trigger.attr('aria-describedby', ttID).attr('title', '').attr('data-original-title', ttText);
        }).on('mouseout', function () {
            $tooltip.remove();
            $trigger.attr('aria-describedby', '').attr('title', ttText).attr('data-original-title', '');
        });
    }
});

function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

$.fn.setTooltipPosition = function($trigger = false, ttPlacement) {
    let $tooltip = $(this),
        ttPosX,
        ttPosY;

    if (!$trigger) return false;

    if (typeof ttPlacement === 'undefined' || 'top' === ttPlacement) {
        ttPosX = $trigger.offset().left + $trigger.outerWidth() / 2 - $tooltip.outerWidth() / 2;
        ttPosY = $trigger.offset().top - viewport().height;
    } else if ('right' === ttPlacement) {
        ttPosX = $trigger.offset().left + $trigger.outerWidth();
        ttPosY = $trigger.offset().top + $trigger.outerHeight() / 2 - $tooltip.outerHeight() / 2;
    } else if ('bottom' === ttPlacement) {
        ttPosX = $trigger.offset().left + $trigger.outerWidth() / 2 - $tooltip.outerWidth() / 2;
        ttPosY = $trigger.offset().top + $trigger.outerHeight();
    } else if ('left' === ttPlacement) {
        ttPosX = $trigger.offset().left - $body.innerWidth();
        ttPosY = $trigger.offset().top + $trigger.outerHeight() / 2 - $tooltip.outerHeight() / 2;
    }

    // @TODO add check for available space for tooltip, else move it to other position

    $tooltip.css('transform', 'translate3d(' + ttPosX + 'px, ' + ttPosY + 'px, 0)');
}

// adjust open tooltip position on window resize
$(window).on('resize', function () {
    $('.tooltip').each(function () {
        let $tooltip = $(this),
            $trigger = $('[aria-describedby="' + $tooltip.attr('id') + '"]'),
            ttPlacement = $trigger.attr('data-placement');

        $tooltip.setTooltipPosition($trigger, ttPlacement);
    });
});
